export default __webpack_public_path__ + "media/images/3-dogs-c59960b8b740e01871cbe19018d561de.svg";